import { vMaska } from 'maska/vue';

import { CustomPlugin } from '@/types';

const plugin: CustomPlugin = {
  install: (app) => {
    app.directive('maska', vMaska);
  },
};

export default plugin;
